import getIterableElements from "../utils/get-iterable-elements";
import { G_elements } from "../utils/globals/elements";
import Container from "./Container";
import intersections from "./utils/intersections";

/**
 * Initializes the Main object
 * @this {ContainerClassProps}
 */
Container.prototype.init = function () {
  this.affectedElements = /** @type {Array<TorusElement>} */ (
    getIterableElements(this.element.querySelectorAll("[data-tor]"))
  );

  intersections(this.element);

  G_elements.set(this.element, this);

  /** Return class */
  return this;
};

export default Container.init;
